import imgVancoAuc from '../images/vanco-auc.png';
import imgCovidDashboard from '../images/covid-dashboard.png';
import imgStockNeuralNetwork from '../images/neural-network.png';

export const portfolioArray = [
	{
		id: '',
		url: 'https://github.com/kpessa/learnwithleon-layout-3',
		title: 'BBC Layout',
		imgSrc: 'https://github.com/kpessa/learnwithleon-layout-3/raw/main/screencast2.gif?raw=true',
		alt: 'screencast for BBC Layout',
		languages: 'React | HTML | SCSS | Responsive Design',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/learnwithleon-layout-1',
		title: 'TechCrunch Layout',
		imgSrc: 'https://github.com/kpessa/learnwithleon-layout-1/raw/main/screencast-responsive.gif?raw-true',
		alt: 'screencast for TechCrunch Layout',
		languages: 'HTML | SCSS | Responsive Design',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/learnwithleon-layout-2',
		title: 'Khan Academy Layout',
		imgSrc: 'https://github.com/kpessa/learnwithleon-layout-2/raw/main/screencast.gif?raw=true',
		alt: 'screencast for Khan Academy Layout',
		languages: 'HTML | SCSS',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/work-day-scheduler',
		title: 'Work Day Scheduler',
		imgSrc: 'https://github.com/kpessa/work-day-scheduler/raw/main/assets/images/demo.gif',
		alt: 'screencast for weather dashboard',
		languages: 'Bootstrap | JQuery | Moment.js | localStorage',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/weather-dashboard',
		title: 'Weather Dashboard',
		imgSrc: 'https://github.com/kpessa/weather-dashboard/raw/main/assets/images/demo.gif',
		alt: 'screencast for weather dashboard',
		languages: 'Bootstrap | JQuery | APIs',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/sequelize-challenge',
		title: 'SQL-Sequelize Challenge!',
		imgSrc: 'https://github.com/kpessa/sequelize-challenge/raw/main/images/screencast.gif',
		alt: 'screencast for sequelize challenge',
		languages: 'SQL | Sequelize | Insomnia',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/four-in-a-row',
		title: 'Four in a row!',
		imgSrc: 'https://github.com/kpessa/four-in-a-row/raw/main/screencast.gif',
		alt: 'screencast of Four in a row web app',
		languages: 'HTML | CSS | JS',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/mysql-challenge',
		title: 'MySQL Challenge - Employee Database CLI',
		imgSrc: 'https://github.com/kpessa/mysql-challenge/raw/main/screencast.gif',
		alt: 'screencast of Employee Database CLI',
		languages: 'SQL | MySQL | Nodejs',
	},
	{
		id: '',
		url: 'https://github.com/mrhumpherys/social-sports',
		title: 'Sports Buzz! - Social Sports',
		imgSrc: 'https://github.com/mrhumpherys/social-sports/blob/main/public/assets/images/buzz.gif?raw=true',
		alt: 'screencast of Sports Buzz web app',
		languages: 'Express | Sequelize | HTML/CSS/JS',
	},
	{
		id: 'novid',
		url: 'https://github.com/Prestongeyer713/novid',
		title: 'Novid - Restaurant search for COVID',
		imgSrc: 'https://user-images.githubusercontent.com/75324665/107859719-6862d280-6e09-11eb-8b0a-dbfc54e8da06.gif',
		alt: 'screencast of novid web app',
		languages: 'JQuery | Leaflet.js | Axios',
	},
	{
		id: 'vanco-auc',
		url: 'https://github.com/kpessa/vanco-auc',
		title: 'Vancomycin AUC Calculator',
		imgSrc: imgVancoAuc,
		alt: 'image of landing page for vanco auc project',
		languages: 'VBA',
	},
	{
		id: '',
		url: 'https://project-2-covid.herokuapp.com/',
		title: 'COVID-19 Dashboard',
		imgSrc: imgCovidDashboard,
		alt: 'screenshot of covid dashboard app',
		languages: 'Python | Flask | Plotly | D3.js | Leaflet',
	},
	{
		id: '',
		url: 'https://billionaire-wealth-management.herokuapp.com/',
		title: 'Stock Neural Network',
		imgSrc: imgStockNeuralNetwork,
		alt: 'screenshot of stock neural network web app',
		languages: 'Python | Bootstrap | Machine Learning | Keras/TensorFlow',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/plotly-js-challenge',
		title: 'Belly Button Biodiversity Dashboard',
		imgSrc: 'https://github.com/kpessa/plotly-js-challenge/blob/main/screencast.gif?raw=true',
		alt: 'screencast demonstrating a dashboard challenge created with belly button biodiversity data',
		languages: 'Python/Flask | Plotly.js',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/code-quiz',
		title: 'Code Quiz',
		imgSrc: 'https://github.com/kpessa/code-quiz/raw/main/screencast.gif',
		alt: 'screencast of code quiz',
		languages: 'HTML | CSS | Vanilla JS',
	},
	{
		id: '',
		url: 'https://github.com/kpessa/password-generator',
		title: 'Password Generator',
		imgSrc: 'https://github.com/kpessa/password-generator/raw/main/screencast.gif',
		alt: 'screencast of password generator',
		languages: 'Boostrap | Vanilla JS ',
	},
];
